<!-- <app-hierarchical-menu
  [attributes]="['categories_de-CH.lvl0', 'categories_de-CH.lvl1', 'categories_de-CH.lvl2']"
  [sortBy]="['name:asc', 'count:desc']"
></app-hierarchical-menu> -->

<app-hierarchical-menu></app-hierarchical-menu>
<!-- <div class="border-t border-gray-200 px-4 py-6">
  <app-clear-filter></app-clear-filter>
</div> -->

<!-- <div class="border-t border-gray-200 px-4 py-6">
  <h3 class="-mx-2 -my-3 flow-root">
    <button
      type="button"
      class="flex w-full items-center justify-between bg-white px-2 py-3 text-gray-400 hover:text-gray-500"
      aria-controls="filter-section-mobile-0"
      aria-expanded="false"
      (click)="showManufacturer.next(!showManufacturer.value)"
    >
      <span class="font-medium text-gray-900">Hersteller</span>
      <span class="ml-6 flex items-center">

        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          *ngIf="!(showManufacturer | async)"
        >
          <path
            d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"
          />
        </svg>

        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          *ngIf="showManufacturer | async"
        >
          <path
            fill-rule="evenodd"
            d="M3 10a.75.75 0 01.75-.75h10.5a.75.75 0 010 1.5H3.75A.75.75 0 013 10z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>
  </h3>
  <div
    class="pt-6"
    id="filter-section-mobile-0"
    [class.hidden]="showManufacturer | async"
  >
    <app-refinement-list
      attribute="manufacturer"
      [sortBy]="['name:asc', 'count:desc']"
    >
    </app-refinement-list>
  </div>
</div> -->

<!-- <div class="border-t border-gray-200 py-4">
  <app-clear-refinements></app-clear-refinements>
</div> -->
